import React from 'react'
import { Popup } from 'react-map-gl'
import { ANCHOR_POSITION } from 'react-map-gl/dist/es5/utils/dynamic-position'
import './Popup.css'

class PopupCSSTransformed extends Popup {
  renderContent() {
    const { closeButton, children } = this.props
    return (
      <div
        key="content"
        ref={ref => {
          this._content = ref
        }}
        className="mapboxgl-popup-content"
      >
        {[
          closeButton && (
            <button
              key="close-button"
              className="mapboxgl-popup-close-button"
              onClick={this._onClose}
            >
              x
            </button>
          ),
          children,
        ]}
      </div>
    )
  }

  _render() {
    const {
      className,
      longitude,
      latitude,
      offsetLeft,
      offsetTop,
      closeOnClick,
    } = this.props

    const [x, y] = this._context.viewport.project([longitude, latitude])
    const positionType = this._getPosition(x, y)
    const anchorPosition = ANCHOR_POSITION[positionType]

    const { left, top } = {
      left: Math.round(x + offsetLeft),
      top: Math.round(y + offsetTop),
    }

    const containerStyle = {
      transform: `translate3d(${left}px, ${top}px, 0)`,
    }

    let anchorStyle = {
      display: 'flex',
      transform: `translate(${-anchorPosition.x * 100}%, ${-anchorPosition.y *
        100}%)`,
    }

    return (
      <div
        ref={this._onContainerLoad}
        className={['mapboxgl-popup', className].filter(x => x).join(' ')}
        style={containerStyle}
        onClick={closeOnClick ? this._onClose : null}
      >
        <div
          className={`mapboxgl-popup-anchor-${positionType}`}
          style={anchorStyle}
        >
          {[this._renderTip(), this.renderContent()]}
        </div>
      </div>
    )
  }
}

export default PopupCSSTransformed
